import { render, staticRenderFns } from "./HomeFooter.vue?vue&type=template&id=2f00924b&"
import script from "./HomeFooter.vue?vue&type=script&lang=js&"
export * from "./HomeFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports